/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable class-methods-use-this */
import {LoggerStrategyType, LoggerUser} from '@src/utility/logger/strategy/type'
import {sentryCaptureMessageFiltered} from '@src/utility/sentry'
import {posthog} from 'posthog-js'

export const posthogOptions = {
  api_host: import.meta.env.VITE_POSTHOG_API_HOST,
  autocapture: false,
  capture_pageleave: false,
  capture_pageview: false,
  capture_performance: false,
  rageclick: true
}

export class PosthogInjector implements LoggerStrategyType {
  init(): void {
    try {
      const apiKey = import.meta.env.VITE_POSTHOG_API_KEY
      if (!apiKey) {
        throw new Error('Posthog API key is not set')
      }
      posthog.init(apiKey, posthogOptions)
    } catch (error) {
      sentryCaptureMessageFiltered(error as Error, 'Error initializing Posthog')
    }
  }

  event(name: string, properties?: Record<string, any> | undefined): void {
    try {
      posthog.capture(name, properties)
    } catch (error) {
      sentryCaptureMessageFiltered(error as Error, 'Error capturing Posthog event')
    }
  }

  setUser(user: LoggerUser): void {
    const {id} = user

    try {
      posthog.identify(id)
    } catch (error) {
      sentryCaptureMessageFiltered(error as Error, 'Error identifying Posthog user')
    }
  }
}
